import { render, staticRenderFns } from "./TwBenchmarkHeader.vue?vue&type=template&id=501e641f&scoped=true"
import script from "./TwBenchmarkHeader.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkHeader.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkHeader.vue?vue&type=style&index=0&id=501e641f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501e641f",
  null
  
)

export default component.exports